
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { formatDateWithTime, formatBool } from "@/utils";
import { ReceiveBarcodeOrderRequest, ReceiveItem } from "@/models/api/barcodeSystem/barcodeOrders/receive";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";


const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeOrderReceiving extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  receiveBarcodeOrderRequest: ReceiveBarcodeOrderRequest;

  @Prop({default: null})
  validationMessages: string[];

  get receiveItems(): Array<ReceiveItem> {
    return this.receiveBarcodeOrderRequest ? this.receiveBarcodeOrderRequest.orderItems : [];
  }

  get statusOptions() : Array<any> {
    return this.receiveBarcodeOrderRequest && this.receiveBarcodeOrderRequest.orderItemStatuses ? 
      this.receiveBarcodeOrderRequest.orderItemStatuses.map(x => ({ label: x.description, value: x.code })) :
      [];
  }

  get damageCodeOptions() : Array<any> {
    return barcodeSystemModule.damageCodes ?
      barcodeSystemModule.damageCodes.map(x => ({ label: x.description, value: x.code })) :
      [];
  }


  get crn(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.crn
      : ""; 
  }

  get companyName(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get displayBillToCompanyId(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.displayBillToCompanyId
      : "";  
  }

  set displayBillToCompanyId(val: string){
  }

  get orderNumber(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.orderNumber
      : ""; 
  }

  set orderNumber(val: string){
  }  
  
  get deliveryType(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.deliveryType
      : ""; 
  }

  set deliveryType(val: string){
  }

  get status(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.status
      : "";  
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.statusDescription
      : "";  
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return this.receiveBarcodeOrderRequest
      ? this.receiveBarcodeOrderRequest.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get orderItemCount() : number
  {
    return this.receiveBarcodeOrderRequest && this.receiveBarcodeOrderRequest.orderItems
      ? this.receiveBarcodeOrderRequest.orderItems.length
      : 0;
  }

  itemIsShort(item) : boolean
  {
    return item.status == 'M';
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val) {
    return formatDateWithTime(val)
  }

  formatBool(val) {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  handleDamagedChanged(data) {
    if(data.damaged)
    {
      data.quantityDamaged = data.quantity;
    }
    else
    {
      data.quantityDamaged = 0;
      data.damageCode = null;
    }
  }

  handleStatusChanged(data) {
    if(this.itemIsShort(data))
    {
      data.quantityReceived = 0;
    }
    else
    {
      data.quantityReceived = data.quantity;
    }
  }

}
